export default "__VITE_ASSET__U1y5IHlr__"